export type AdminNavigationItem = {
    title: string;
    path?: string;
    icon?: string;
    role?: string[] | 'SUPER_ADMIN' | 'ADMIN' | 'GUEST';
    isSlider?: boolean;
};

const adminNavigationConfig: AdminNavigationItem[] = [
    {
        title: 'Dashboard',
        path: '/dashboard',
        icon: 'fas fa-tachometer-alt',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: true,
    },
    {
        title: 'Vehicles',
        path: '/vehicles',
        icon: 'fas fa-car',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Users',
        path: '/users',
        icon: 'fas fa-users',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Agents',
        path: '/agents',
        icon: 'fa-regular fa-user-bounty-hunter',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Insurance',
        path: '/insurance',
        icon: 'fas fa-shield-alt',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Tax',
        path: '/tax',
        icon: 'fas fa-file-invoice-dollar',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Bookings',
        path: '/bookings',
        icon: 'fas fa-book',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: true,
    },
    {
        title: 'Checkout',
        path: '/checkout',
        icon: 'fas fa-shopping-cart',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: true,
    },
    {
        title: 'Return',
        path: '/return',
        icon: 'fas fa-undo',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: true,
    },
    {
        title: 'Others',
        path: '/others',
        icon: 'fas fa-ellipsis-h',
        role: ['SUPER_ADMIN'],
        isSlider: true,
    },
    {
        title: 'Admin Profile',
        path: '/admin-profile',
        icon: 'fas fa-user',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: true,
    },
    {
        title: 'Checkout Detail',
        path: '/checkout/:id',
        icon: 'fas fa-shopping-cart',
        role: ['SUPER_ADMIN', 'ADMIN'],
        isSlider: false,
    },

];


export default adminNavigationConfig;